export const manualFleet: Record<string, readonly [string, string, string, string]> = {};
